import { Text } from '@fluentui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { getTokenExpiryDate } from '../../../shared/utils/date';
import Loader from '../../common/components/loader/Loader';
import { useGetTokens } from './api/useGetTokens';
import { CreateTokenBtn } from './components/CreateTokenBtn';
import { DeleteTokenBtn } from './components/DeleteTokenBtn';

import cardStyles from '../../../theme/styles/Card.module.css';
import tableStyles from './publicApi.module.css';

export const PublicApi = () => {
  const { data, isLoading } = useGetTokens();
  const { t } = useTranslation();

  return (
    <div className={cardStyles.card}>
      <div className={cardStyles.card_content}>
        <CreateTokenBtn />

        <div>
          {isLoading && <Loader />}
          {data && (
            <>
              <div className={tableStyles.table}>
                <div className={`${tableStyles.row} ${tableStyles.header}`}>
                  <div>{t('common:clientSecretName')}</div>
                  <div>{t('common:clientId')}</div>
                  <div>{t('common:expires')}</div>
                  <div className={tableStyles.action}>{t('common:action')}</div>
                </div>
                {data.map((item) => {
                  const expiryDateData = getTokenExpiryDate(item.updatedOn, item.timeToLive);
                  const expiryDate = expiryDateData.isValid
                    ? expiryDateData.expiresAt
                    : <span style={{ fontWeight: 'bold', color: 'var(--theme-palette-error-default)' }}>{t('common:expired')}</span>

                  return (
                    <div key={item.clientId} className={tableStyles.row}>
                      <div>{item.name}</div>
                      <div>{item.clientId}</div>
                      <div>{expiryDate}</div>
                      <div className={tableStyles.action}>
                        <DeleteTokenBtn clientId={item.clientId} />
                      </div>
                    </div>
                  )
                })}
                {data && data?.length < 1 && (
                  <Text
                    variant="xLarge"
                    block
                    className={tableStyles.noTokensText}
                  >{t('common:noSecrets')}</Text>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  )
};